import React from 'react';

const DurationIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M2.4344 9.88771L4.89073 12.9576M4.89073 12.9576L8.0411 10.1781M4.89073 12.9576C4.78896 11.7115 4.91295 10.3936 5.40625 9.14072C7.10883 4.81646 11.9341 2.66633 16.1823 4.33895C20.4305 6.01158 22.4946 10.8742 20.792 15.1985C19.0894 19.5228 14.2642 21.6729 10.016 20.0003C8.78513 19.5157 7.73912 18.7621 6.91895 17.8362" stroke="#525365" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M12.8081 12.9987V8.82031" stroke="#525365" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.8081 13H16.1775" stroke="#525365" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default DurationIcon;
